import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { TimeTrackerBaseApi } from '../../providers/generic.service';
import { Auth0Provider } from '../../providers/auth0.provider';
import { Observable } from 'rxjs/Observable';
import { IUser } from '../../../typings/timetracker/timetracker';

/**
 * Generated class for the ProfilePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})
export class ProfilePage {

  currentUser$: Observable<IUser>;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private $alertCtrl: AlertController,
    private $timetrackerAPI: TimeTrackerBaseApi,
    private $auth0Provider: Auth0Provider ) {
      this.currentUser$ = this.$timetrackerAPI.selectCurrentUser();
      // this.currentUser$.subscribe( blaat => console.log( '===>', blaat ) );
    }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProfilePage');
  }

  logout() {
    this.$alertCtrl.create({
      title: 'Uitloggen',
      message: 'Weet je zeker dat je wilt uitloggen?',
      buttons: [
        {
          text: 'Annuleren',
          role: 'cancel'
        },
        {
          text: 'Uitloggen',
          handler: () => {
            this.$auth0Provider.logout();
          }
        }
      ]
    }).present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts